export default __webpack_public_path__ + "static/media/marital.7b36eb94.png";